The response from the `setDisabledFeatures` mutation.
